export default class Flight {
  arrival = ''
  arrivalDate = ''
  arrivalDay = ''
  arrivalTime = ''
  departure = ''
  departureDate = ''
  departureDay = ''
  departureTime = ''
  destination = ''
  flight = {}
  flightId = ''
  flightLegs = []
  flightNumber = ''
  origin = ''
  sta = ''
  staUtc = ''
  std = ''
  stdUtc = ''
}
